






























import Vue from "vue";
import { Component } from "vue-property-decorator";
import { http } from "@/shared/https";
import Alert from "@/components/common/Alert/Alert.vue";
import AuthService from "@/services/auth.service";

const auth = new AuthService();
const defaut_layout: string = "default";

@Component({
  components: {
    Alert,
  },
})
export default class AppComponent extends Vue {
  passwordAlert: boolean = false;
  passwordExpiryDays: number;
  passwordContent = "";

  get layout() {
    document.title = this.$t("IUCN Grants Portal").toString();
    return (this.$route.meta.layout || defaut_layout) + "-layout";
  }

  mounted() {
    if (
      sessionStorage.getItem("passwordNotify") &&
      sessionStorage.getItem("passwordNotify") === "0"
    ) {
      return;
    }

    auth.isLoggedIn().then((isLoggedIn: boolean) => {
      if (isLoggedIn) {
        return http.get("/api/Dashboard/GetUserInfo").then((resp) => {
          this.passwordAlert = resp.data.PasswordExpiry;
          if (resp.data.PasswordExpiryDays > 0)
            this.passwordContent = `${this.$t(
              "Your password will expire in"
            )} ${resp.data.PasswordExpiryDays} ${this.$t("days")}. ${this.$t(
              "Do you want to change it now?"
            )}`;
          else
            this.passwordContent = this.$t(
              "Do you want to change your password to protect your IUCN Grants Portal account?"
            ).toString();
        });
      }
    });
  }

  onOK(alert) {
    this.onCancel();

    this.$router.push({
      name: "profile",
    });
  }

  onCancel() {
    this.passwordAlert = false;
    sessionStorage.setItem("passwordNotify", "0");
  }
}
